import React, { FunctionComponent } from 'react'
import styles from './StreamerLoad.module.sass'
import { Classes, Colors } from '../../../../../styles'
import fileSize from 'filesize'
import { clamp, ordNumber } from 'fp-ts/Ord'
import clsx from 'clsx'
import Spacer from '../../../../etc/Spacer'

interface Props {
    size: number,
    min: number,
    max: number,
}

const clampNumber = clamp(ordNumber)

const StreamerLoad: FunctionComponent<Props> = ({size, min, max}) => {
    const percent = (size / (max / 100)) || 0
    const color = (size < min || size > max)? Colors.red: Colors.green

    return <div className={styles.load}>
        <div className={styles.gauge}>
            <div className={styles.fill} style={{width: `${clampNumber(0, max)(percent)}%`, background: color}}/>
        </div>
        <div className={clsx(Classes.f9, Classes.flex)}>
            <span className={Classes.cGrey}>Стриммер заполнен на &nbsp;</span>
            <span style={{color}}>{percent.toFixed(2)}%</span>
            <Spacer/>
            <span style={{color}}>{fileSize(size)} &nbsp;</span>
            <span className={Classes.cPurpleDark}>из {fileSize(max)}</span>
        </div>
    </div>
}

export default StreamerLoad